interface Props {
  getnumber?: any;
  bgcolor?: any;
  fontColor?: any;
  checked?: boolean;
  themeMode?: String
}
export function CircleSVG({ getnumber, bgcolor, fontColor, themeMode }: Props) {
  let circleFill = (bgcolor == "#871014" || bgcolor == "#000000") ? "white" : "black";
  let textX = "0";
  let textY = "0";
  if (getnumber.length == 1) {
    textX = "10";
    textY = "21";
  } else if (getnumber.length == 2) {
    textX = "5";
    textY = "21";
  } else if (getnumber.length == 3) {
    textX = "2";
    textY = "20";
  }
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3001_89021)">
        <rect width="29.3827" height="29.3827" rx="14.6914" fill={bgcolor} />
        <g opacity="0.2">
          <circle
            cx="21.9423"
            cy="23.2377"
            r="1.89566"
            transform="rotate(-90 21.9423 23.2377)"
            fill={circleFill}
          />
          <circle
            cx="21.9423"
            cy="8.07266"
            r="1.89566"
            transform="rotate(-90 21.9423 8.07266)"
            fill={circleFill}
          />
          <circle
            cx="2.03793"
            cy="23.2377"
            r="1.89566"
            transform="rotate(-90 2.03793 23.2377)"
            fill={circleFill}
          />
          <circle
            cx="2.03793"
            cy="8.07266"
            r="1.89566"
            transform="rotate(-90 2.03793 8.07266)"
            fill={circleFill}
          />
          <circle
            cx="19.5729"
            cy="18.0247"
            r="1.42174"
            transform="rotate(-90 19.5729 18.0247)"
            fill={circleFill}
          />
          <circle
            cx="19.5729"
            cy="2.85954"
            r="1.42174"
            transform="rotate(-90 19.5729 2.85954)"
            fill={circleFill}
          />
          <circle
            cx="-0.331918"
            cy="18.0247"
            r="1.42174"
            transform="rotate(-90 -0.331918 18.0247)"
            fill={circleFill}
          />
          <circle
            cx="-0.331918"
            cy="2.85954"
            r="1.42174"
            transform="rotate(-90 -0.331918 2.85954)"
            fill={circleFill}
          />
          <circle
            cx="16.7292"
            cy="26.5554"
            r="2.36957"
            transform="rotate(-90 16.7292 26.5554)"
            fill={circleFill}
          />
          <circle
            cx="16.7293"
            cy="11.3898"
            r="2.36957"
            transform="rotate(-90 16.7293 11.3898)"
            fill={circleFill}
          />
          <circle
            cx="24.3117"
            cy="18.0246"
            r="2.36957"
            transform="rotate(-90 24.3117 18.0246)"
            fill={circleFill}
          />
          <circle
            cx="24.3117"
            cy="2.85946"
            r="2.36957"
            transform="rotate(-90 24.3117 2.85946)"
            fill={circleFill}
          />
          <circle
            cx="4.40735"
            cy="18.0246"
            r="2.36957"
            transform="rotate(-90 4.40735 18.0246)"
            fill={circleFill}
          />
          <circle
            cx="4.40735"
            cy="2.85946"
            r="2.36957"
            transform="rotate(-90 4.40735 2.85946)"
            fill={circleFill}
          />
          <circle
            cx="14.8336"
            cy="18.0247"
            r="1.42174"
            transform="rotate(-90 14.8336 18.0247)"
            fill={circleFill}
          />
          <circle
            cx="14.8336"
            cy="2.85954"
            r="1.42174"
            transform="rotate(-90 14.8336 2.85954)"
            fill={circleFill}
          />
          <circle
            cx="10.5682"
            cy="27.0293"
            r="0.94783"
            transform="rotate(-90 10.5682 27.0293)"
            fill={circleFill}
          />
          <circle
            cx="26.6815"
            cy="24.1856"
            r="0.94783"
            transform="rotate(-90 26.6815 24.1856)"
            fill={circleFill}
          />
          <circle
            cx="26.6815"
            cy="9.02049"
            r="0.94783"
            transform="rotate(-90 26.6815 9.02049)"
            fill={circleFill}
          />
          <circle
            cx="6.77718"
            cy="24.1856"
            r="0.94783"
            transform="rotate(-90 6.77718 24.1856)"
            fill={circleFill}
          />
          <circle
            cx="6.77718"
            cy="9.02049"
            r="0.94783"
            transform="rotate(-90 6.77718 9.02049)"
            fill={circleFill}
          />
          <circle
            cx="14.3597"
            cy="23.2378"
            r="0.94783"
            transform="rotate(-90 14.3597 23.2378)"
            fill={circleFill}
          />
          <circle
            cx="14.3597"
            cy="8.07274"
            r="0.94783"
            transform="rotate(-90 14.3597 8.07274)"
            fill={circleFill}
          />
          <circle
            cx="30.4727"
            cy="20.3944"
            r="2.84349"
            transform="rotate(-90 30.4727 20.3944)"
            fill={circleFill}
          />
          <circle
            cx="30.4727"
            cy="5.22933"
            r="2.84349"
            transform="rotate(-90 30.4727 5.22933)"
            fill={circleFill}
          />
          <circle
            cx="9.62051"
            cy="19.4467"
            r="1.89566"
            transform="rotate(-90 9.62051 19.4467)"
            fill={circleFill}
          />
          <circle
            cx="10.5683"
            cy="5.22894"
            r="1.89566"
            transform="rotate(-90 10.5683 5.22894)"
            fill={circleFill}
          />
          <circle
            cx="30.4726"
            cy="27.0293"
            r="1.89566"
            transform="rotate(-90 30.4726 27.0293)"
            fill={circleFill}
          />
          <circle
            cx="30.4726"
            cy="11.8637"
            r="1.89566"
            transform="rotate(-90 30.4726 11.8637)"
            fill={circleFill}
          />
          <circle
            cx="11.0421"
            cy="14.2336"
            r="1.42174"
            transform="rotate(-90 11.0421 14.2336)"
            fill={circleFill}
          />
          <circle
            cx="23.3639"
            cy="28.4509"
            r="1.42174"
            transform="rotate(-90 23.3639 28.4509)"
            fill={circleFill}
          />
          <circle
            cx="23.3639"
            cy="13.2858"
            r="1.42174"
            transform="rotate(-90 23.3639 13.2858)"
            fill={circleFill}
          />
          <circle
            cx="3.45953"
            cy="28.4509"
            r="1.42174"
            transform="rotate(-90 3.45953 28.4509)"
            fill={circleFill}
          />
          <circle
            cx="3.45953"
            cy="13.2858"
            r="1.42174"
            transform="rotate(-90 3.45953 13.2858)"
            fill={circleFill}
          />
          <circle
            cx="17.6769"
            cy="21.8161"
            r="1.42174"
            transform="rotate(-90 17.6769 21.8161)"
            fill={circleFill}
          />
          <circle
            cx="17.6769"
            cy="6.65107"
            r="1.42174"
            transform="rotate(-90 17.6769 6.65107)"
            fill={circleFill}
          />
        </g>
        <text
          fill={circleFill}
          y={textY}
          x={textX}
          style={{            
            fontWeight: 700,
            fontSize: "14.69",
            textAlign: "center",
            letterSpacing: "0.02em",
            width: "18px",
            height: "21px",
          }}
        >
          {getnumber}
        </text>
        {/* <path d="M11.0467 10.4104V20.8766H8.98075V12.792L6.49871 13.5811V11.9527L10.8243 10.4104H11.0467ZM21.8856 19.2625V20.8766H14.7408V19.4992L18.1195 15.8766C18.4591 15.4988 18.7269 15.1664 18.9229 14.8795C19.119 14.5878 19.2601 14.3271 19.3462 14.0976C19.4371 13.8633 19.4825 13.6409 19.4825 13.4304C19.4825 13.1148 19.4299 12.8446 19.3247 12.6198C19.2195 12.3903 19.064 12.2133 18.8584 12.089C18.6575 11.9647 18.4088 11.9025 18.1123 11.9025C17.7967 11.9025 17.5241 11.979 17.2946 12.132C17.0698 12.2851 16.8976 12.4979 16.7781 12.7705C16.6633 13.0431 16.6059 13.3515 16.6059 13.6959H14.5328C14.5328 13.0742 14.681 12.5051 14.9775 11.9886C15.274 11.4673 15.6925 11.0536 16.2329 10.7476C16.7733 10.4367 17.4141 10.2813 18.1554 10.2813C18.8871 10.2813 19.504 10.4008 20.0062 10.64C20.5131 10.8743 20.8957 11.2138 21.1539 11.6586C21.4169 12.0986 21.5485 12.6246 21.5485 13.2368C21.5485 13.5811 21.4935 13.9182 21.3835 14.2482C21.2735 14.5734 21.1157 14.8986 20.91 15.2238C20.7092 15.5442 20.4653 15.8694 20.1783 16.1994C19.8914 16.5294 19.5733 16.8713 19.2242 17.2252L17.4093 19.2625H21.8856Z" fill="black" /> */}
      </g>
      <defs>
        <clipPath id="clip0_3001_89021">
          <rect width="29.3827" height="29.3827" rx="14.6914" fill={"black"} />
        </clipPath>
      </defs>
    </svg>
  );
}
export function RightSideArrow() {
  return (
    <svg
      width="20"
      height="9"
      viewBox="0 0 20 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.00012 5.74684C1.92363 5.03645 5.02961 3.30817 9.13757 5.06872C13.8844 7.10308 16.6744 4.92014 17.9531 3.71248"
        stroke="black"
        strokeWidth="1.35624"
        strokeLinecap="round"
      />
      <path
        d="M13.8844 1.60065L18.8505 3.01802L16.8463 8.7426"
        stroke="black"
        strokeWidth="1.35624"
      />
    </svg>
  );
}
export function UpSideArrow({ fill }: any) {
  return (
    <svg
      width="11"
      height="18"
      viewBox="0 0 11 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 5.5L5.5 1L10 5.5" stroke={fill} strokeLinecap="round" />
      <path d="M5.5 1V17.5" stroke={fill} strokeLinecap="round" />
    </svg>
  );
}
export function DownSideArrow({ fill }: any) {
  return (
    <svg
      width="11"
      height="22"
      viewBox="0 0 11 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 13L5.5 17.5L10 13" stroke={fill} strokeLinecap="round" />
      <path d="M5.5 17.5V1" stroke={fill} strokeLinecap="round" />
    </svg>
  );
}
export function DropDownArrow() {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M2.64395 0.549998L7.10595 5.012L11.5679 0.549998C12.0164 0.101498 12.7409 0.101498 13.1894 0.549998C13.6379 0.998498 13.6379 1.723 13.1894 2.1715L7.91095 7.45C7.46245 7.8985 6.73795 7.8985 6.28945 7.45L1.01095 2.1715C0.795609 1.95664 0.674591 1.66494 0.674591 1.36075C0.674591 1.05655 0.795609 0.764854 1.01095 0.549998C1.45945 0.112998 2.19545 0.101498 2.64395 0.549998Z"
        fill="black"
      />
    </svg>
  );
}

export function SelectUpArrow() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.10975 13.125L10.5048 9.73001L13.8998 13.125C14.241 13.4663 14.7923 13.4663 15.1335 13.125C15.4748 12.7838 15.4748 12.2325 15.1335 11.8913L11.1173 7.87501C10.776 7.53376 10.2248 7.53376 9.8835 7.87501L5.86725 11.8913C5.70341 12.0547 5.61133 12.2767 5.61133 12.5081C5.61133 12.7396 5.70341 12.9615 5.86725 13.125C6.2085 13.4575 6.7685 13.4663 7.10975 13.125Z"
        fill="black"
      />
    </svg>
  );
}
export function SelectDownArrow() {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.10975 7.87502L10.5048 11.27L13.8998 7.87502C14.241 7.53377 14.7923 7.53377 15.1335 7.87502C15.4748 8.21627 15.4748 8.76752 15.1335 9.10877L11.1173 13.125C10.776 13.4663 10.2248 13.4663 9.8835 13.125L5.86725 9.10877C5.70341 8.94529 5.61133 8.72335 5.61133 8.49189C5.61133 8.26044 5.70341 8.03849 5.86725 7.87502C6.2085 7.54252 6.7685 7.53377 7.10975 7.87502Z"
        fill="black"
      />
    </svg>
  );
}

export function ConditionColorSelection({ checked, bgcolor }: Props) {
  let circleFill = bgcolor == "#000000" ? "white" : "black";
  let gOpacity = bgcolor == "#000000" ? "0.5" : "0.2";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <g clipPath="url(#clip0_3371_66988)">
        <rect width="34" height="34" rx="14" fill={bgcolor} />
        <g opacity={gOpacity}>
          <circle
            cx="25.3889"
            cy="26.8894"
            r="2.19355"
            transform="rotate(-90 25.3889 26.8894)"
            fill={circleFill}
          />
          <circle
            cx="25.3889"
            cy="9.3412"
            r="2.19355"
            transform="rotate(-90 25.3889 9.3412)"
            fill={circleFill}
          />
          <circle
            cx="2.35761"
            cy="26.8894"
            r="2.19355"
            transform="rotate(-90 2.35761 26.8894)"
            fill={circleFill}
          />
          <circle
            cx="2.35761"
            cy="9.3412"
            r="2.19355"
            transform="rotate(-90 2.35761 9.3412)"
            fill={circleFill}
          />
          <circle
            cx="22.6491"
            cy="20.8571"
            r="1.64516"
            transform="rotate(-90 22.6491 20.8571)"
            fill={circleFill}
          />
          <circle
            cx="22.6491"
            cy="3.30888"
            r="1.64516"
            transform="rotate(-90 22.6491 3.30888)"
            fill={circleFill}
          />
          <circle
            cx="-0.384136"
            cy="20.8571"
            r="1.64516"
            transform="rotate(-90 -0.384136 20.8571)"
            fill={circleFill}
          />
          <circle
            cx="-0.384136"
            cy="3.30888"
            r="1.64516"
            transform="rotate(-90 -0.384136 3.30888)"
            fill={circleFill}
          />
          <circle
            cx="19.3572"
            cy="30.7283"
            r="2.74194"
            transform="rotate(-90 19.3572 30.7283)"
            fill={circleFill}
          />
          <circle
            cx="19.3572"
            cy="13.1796"
            r="2.74194"
            transform="rotate(-90 19.3572 13.1796)"
            fill={circleFill}
          />
          <circle
            cx="28.1326"
            cy="20.857"
            r="2.74194"
            transform="rotate(-90 28.1326 20.857)"
            fill={circleFill}
          />
          <circle
            cx="28.1326"
            cy="3.3088"
            r="2.74194"
            transform="rotate(-90 28.1326 3.3088)"
            fill={circleFill}
          />
          <circle
            cx="5.09936"
            cy="20.857"
            r="2.74194"
            transform="rotate(-90 5.09936 20.857)"
            fill={circleFill}
          />
          <circle
            cx="5.09936"
            cy="3.3088"
            r="2.74194"
            transform="rotate(-90 5.09936 3.3088)"
            fill={circleFill}
          />
          <circle
            cx="17.1647"
            cy="20.8571"
            r="1.64516"
            transform="rotate(-90 17.1647 20.8571)"
            fill={circleFill}
          />
          <circle
            cx="17.1647"
            cy="3.30888"
            r="1.64516"
            transform="rotate(-90 17.1647 3.30888)"
            fill={circleFill}
          />
          <circle
            cx="12.2276"
            cy="31.2768"
            r="1.09677"
            transform="rotate(-90 12.2276 31.2768)"
            fill={circleFill}
          />
          <circle
            cx="30.8741"
            cy="27.9861"
            r="1.09677"
            transform="rotate(-90 30.8741 27.9861)"
            fill={circleFill}
          />
          <circle
            cx="30.8741"
            cy="10.438"
            r="1.09677"
            transform="rotate(-90 30.8741 10.438)"
            fill={circleFill}
          />
          <circle
            cx="7.84091"
            cy="27.9861"
            r="1.09677"
            transform="rotate(-90 7.84091 27.9861)"
            fill={circleFill}
          />
          <circle
            cx="7.84091"
            cy="10.438"
            r="1.09677"
            transform="rotate(-90 7.84091 10.438)"
            fill={circleFill}
          />
          <circle
            cx="16.6163"
            cy="26.8894"
            r="1.09677"
            transform="rotate(-90 16.6163 26.8894)"
            fill={circleFill}
          />
          <circle
            cx="16.6163"
            cy="9.34129"
            r="1.09677"
            transform="rotate(-90 16.6163 9.34129)"
            fill={circleFill}
          />
          <circle
            cx="35.261"
            cy="23.5992"
            r="3.29032"
            transform="rotate(-90 35.261 23.5992)"
            fill={circleFill}
          />
          <circle
            cx="35.261"
            cy="6.05105"
            r="3.29032"
            transform="rotate(-90 35.261 6.05105)"
            fill={circleFill}
          />
          <circle
            cx="11.133"
            cy="22.5026"
            r="2.19355"
            transform="rotate(-90 11.133 22.5026)"
            fill={circleFill}
          />
          <circle
            cx="12.2287"
            cy="6.05062"
            r="2.19355"
            transform="rotate(-90 12.2287 6.05062)"
            fill={circleFill}
          />
          <circle
            cx="35.26"
            cy="31.2767"
            r="2.19355"
            transform="rotate(-90 35.26 31.2767)"
            fill={circleFill}
          />
          <circle
            cx="35.26"
            cy="13.728"
            r="2.19355"
            transform="rotate(-90 35.26 13.728)"
            fill={circleFill}
          />
          <circle
            cx="12.776"
            cy="16.4703"
            r="1.64516"
            transform="rotate(-90 12.776 16.4703)"
            fill={circleFill}
          />
          <circle
            cx="27.0358"
            cy="32.9218"
            r="1.64516"
            transform="rotate(-90 27.0358 32.9218)"
            fill={circleFill}
          />
          <circle
            cx="27.0358"
            cy="15.3736"
            r="1.64516"
            transform="rotate(-90 27.0358 15.3736)"
            fill={circleFill}
          />
          <circle
            cx="4.00258"
            cy="32.9218"
            r="1.64516"
            transform="rotate(-90 4.00258 32.9218)"
            fill={circleFill}
          />
          <circle
            cx="4.00258"
            cy="15.3736"
            r="1.64516"
            transform="rotate(-90 4.00258 15.3736)"
            fill={circleFill}
          />
          <circle
            cx="20.4538"
            cy="25.2444"
            r="1.64516"
            transform="rotate(-90 20.4538 25.2444)"
            fill={circleFill}
          />
          <circle
            cx="20.4538"
            cy="7.69621"
            r="1.64516"
            transform="rotate(-90 20.4538 7.69621)"
            fill={circleFill}
          />
        </g>
        {checked && (
          <path d="M9 16L14 21.5L25.5 10" stroke="white" strokeWidth="3" />
        )}
      </g>
      {checked && (
        <rect
          x="0.75"
          y="0.75"
          width="32.5"
          height="32.5"
          rx="13.25"
          stroke="black"
          strokeWidth="1.5"
        />
      )}
      <defs>
        <clipPath id="clip0_3371_66988">
          <rect width="34" height="34" rx="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BulletsDots({ bgcolor }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
    >
      <circle cx="4.5" cy="4.5" r="4.5" fill={bgcolor} />
    </svg>
  );
}
